import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const STATUS_LABEL = { available: "Available", leased: "Leased", sold: "Sold" };

export default function PropertyCard({ property, index = 0 }) {
  const leased = property.status !== "available";
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, ease: [0.19, 1, 0.22, 1], delay: (index % 3) * 0.08 }}
    >
      <Link
        to={`/property/${property.id}`}
        data-testid={`property-card-${property.id}`}
        className="group block border border-border bg-card hover-invert hover:bg-primary hover:text-primary-foreground"
      >
        <div className="relative overflow-hidden aspect-[4/3] bg-muted">
          <img
            src={property.images?.[0]}
            alt={property.title}
            className="h-full w-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.19,1,0.22,1)] group-hover:scale-105"
            style={{ filter: leased ? "grayscale(1)" : "none" }}
          />
          <span className="absolute top-4 left-4 overline bg-background/90 text-foreground px-3 py-1">
            {property.property_type}
          </span>
          <span className={`absolute top-4 right-4 overline px-3 py-1 ${leased ? "bg-foreground/70 text-background" : "bg-background/90 text-foreground"}`}>
            {STATUS_LABEL[property.status]}
          </span>
        </div>
        <div className="p-6">
          <div className="flex items-start justify-between gap-4">
            <h3 className="font-display text-2xl font-medium tracking-tight leading-tight">{property.title}</h3>
            <ArrowUpRight className="shrink-0 mt-1 transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" size={22} />
          </div>
          <p className="text-sm text-muted-foreground group-hover:text-primary-foreground/70 mt-2">{property.location}</p>
          <div className="mt-6 flex items-center justify-between font-mono text-xs uppercase tracking-wider">
            <span>{property.price}</span>
            <span>{property.size_sqft.toLocaleString()} m²</span>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
